import { useState, useEffect, useContext } from 'react'
import Select from 'react-select';
import ContextStates from '../../context/ContextStates'
import axios from 'axios'
import { Url } from '../Url'
import FormVentas from '../forms/formVentas'


const FormPresupuestos = () => {
    const [clientes, setClientes] = useState([])
    const { cliente, setCliente, modify, setFormPrev, setFormView, setViewOpen } = useContext(ContextStates)

    useEffect(() => {
        const consultaClientes = async () => {
            const formData = new FormData()
            //formData.append('idusuario', idUsuario)
            formData.append('busqueda', "")
            try {
                const response = await axios({
                    url: Url + 'api/listClientes.php',
                    method: 'POST',
                    data: formData,
                })
                setClientes(response.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        consultaClientes()
    }, [modify])

    const handleSelect = (item) => {
        setCliente(item)
        //console.log(item)
    }

    const handleAdd = () => {
        
        setFormView(30)
        setViewOpen(true)
    }

    return (
        <div className="transition-all w-full pt-5 sm:p-3 mt-5">
            {cliente.id ? (
                <div className='w-full'>
                    <div className='w-10/12 mx-auto flex'>
                        <h2 className='text-xl text-gray-800 uppercase text-center'>Cliente: {`${cliente.nombre} ${cliente.apellido}`}</h2>
                        <button
                            type='button'
                            className='ml-5 bg-orange-500 text-white p-2 rounded-xl uppercase'
                            onClick={()=>setCliente({})}
                        >Seleccionar otro cliente</button>
                    </div>
                    <FormVentas />
                </div>
            ) : (
                <div className='w-full mt-5 mb-10 bg-gray-50 rounded-lg p-5'>
                    <div className="sm:items-start">
                        <Select
                            options={clientes}
                            placeholder="Seleccione Cliente"
                            onChange={(value) => handleSelect(value)}
                            name='sCliente'
                        />
                        <button type='button'
                            className='p-3 bg-orange-500 text-white uppercase font-semibold rounded'
                            onClick={() => handleAdd()}
                        >
                            Agregar Cliente
                        </button>
                    </div>
                </div>

            )}

        </div>
    )
}

export default FormPresupuestos